export var addFilterButtonDataAttribute = 'add-filter-button';
export var applyFilterButtonDataAttibute = 'filter-apply-button';
export var booleanOperatorChangeDataAttribute = "change-boolean-operator";
export var booleanOperatorLabelDataAttribute = 'boolean-operator-label';
export var changeFilterOperator = "change-filter-operator";
export var clearFilterButtonDataAttribute = 'filter-clear-button';
export var filterLimitWarningDataAttribute = 'filter-limit-warning';
export var removeFilterButtonDataAttribute = 'remove-filter-button';
export var sortAscendingButtonDataAttribute = 'sort-asc-button';
export var sortDescendingButtonDataAttribute = 'sort-desc-button';
export var textFilterInputDataAttribute = 'text-filter-input';
export var equalsOptionsSelectDataAttribute = 'equals-options-select';